<div class="page-innder-body portlet light h-100">
  <div class="portlet-body h-100">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="dsSignup container border p-4 border-light">
        <form #form="ngForm" novalidate class="form-horizontal">

          <!-- Name Fields -->
          <div class="row">
            <div class="col-6">
              <div class="form-group p-field">
                <label for="FirstName" class="form-label">
                  <span class="text-danger">*</span> {{ 'signup.firstName' | transloco }}
                </label>
                <input type="text" id="FirstName" pInputText [placeholder]="'signup.firstName' | transloco"
                  class="form-control form-control-lg"
                  [(ngModel)]="signupForm.FirstName"
                  [disabled]="isExternalInviteFound"
                  name="FirstName" required>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group p-field">
                  <label for="LastName" class="form-label">
                    <span class="text-danger">*</span> {{ 'signup.lastName' | transloco }}
                  </label>
                  <input type="text" id="LastName" pInputText [placeholder]="'signup.lastName' | transloco"
                    class="form-control form-control-lg"
                    [(ngModel)]="signupForm.LastName"
                    [disabled]="isExternalInviteFound"
                    name="LastName" required>
                  </div>
                </div>
              </div>

              <!-- Email Field -->
              <div class="form-group p-field">
                <label for="EmailAddress" class="form-label">
                  <span class="text-danger">*</span> {{ 'signup.emailAddress' | transloco }}
                </label>
                <input type="text" id="EmailAddress" pInputText [placeholder]="'signup.emailAddress' | transloco"
                  class="form-control form-control-lg"
                  [(ngModel)]="signupForm.Email"
                  name="email" [disabled]="isExternalInviteFound" required>
                </div>

                <!-- Password Fields -->
                <div class="row">
                  <div class="col-6">
                    <div class="form-group p-field">
                      <label for="Password" class="form-label">
                        <span class="text-danger">*</span> {{ 'signup.password' | transloco }}
                      </label>
                      <input type="password" id="password" pPassword [placeholder]="'signup.password' | transloco"
                        class="form-control form-control-lg"
                        [(ngModel)]="signupForm.Password"
                        name="password" required>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group p-field">
                        <label for="confirmPassword" class="form-label">
                          <span class="text-danger">*</span> {{ 'signup.confirmPassword' | transloco }}
                        </label>
                        <input type="password" id="confirmPassword" pPassword [placeholder]="'signup.confirmPassword' | transloco"
                          class="form-control form-control-lg"
                          [(ngModel)]="signupForm.ConfirmPassword"
                          name="confirmPassword" required>
                          @if (isPasswordMismatch()) {
                            <div class="text-danger">
                              {{ 'signup.passwordsDoNotMatch' | transloco }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>

                    <!-- Business Name Field (for Gallery Account) -->
                    <!-- <div *ngIf="signupForm.AccountType === 'Gallery'" class="form-group p-field mt-3">
                    <label for="BusinessName" class="form-label">Business Name</label>
                    <input type="text" id="BusinessName" pInputText placeholder="Business Name"
                      class="form-control form-control-lg"
                      [(ngModel)]="signupForm.BusinessName"
                      name="businessName">
                    </div> -->

                    <!-- Account Type Radio Buttons -->
                    <div class="dsRadio form-group mt-2">
                      <label for="accountType" class="form-label">
                        <span class="text-danger">*</span> {{ 'signup.accountType' | transloco }}
                      </label>
                      <div class="d-flex justify-content-start">
                        <div class="d-flex align-items-center">
                          <p-radioButton name="accountType" class="dsRadio" value="Artist" inputId="AccountTypeArtist"
                            [(ngModel)]="signupForm.AccountType"
                            [disabled]="isExternalInviteFound">
                          </p-radioButton>
                          <label for="AccountTypeArtist" class="dsRadioLabel ms-2">{{ 'signup.artist' | transloco }}</label>
                        </div>
                        <div class="d-flex align-items-center ms-3">
                          <p-radioButton name="accountType" value="Gallery" class="fs-2" inputId="AccountTypeGallery"
                            [(ngModel)]="signupForm.AccountType"
                            [disabled]="isExternalInviteFound">
                          </p-radioButton >
                          <label for="AccountTypeGallery" class="dsRadioLabel ms-2">{{ 'signup.gallery' | transloco }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- Submit Button -->
                    <button type="button" pButton  size="medium"
                      class="dsSignupButton p-element p-button-sm mt-5 w-100 p-button p-component"
                      (click)="signUp()"
                      [disabled]="!form.valid">
                      <span class="p-button-label">{{ 'signup.getFreePortal' | transloco }}</span>
                    </button>
                  </form>
                </div>

              </div>
            </div>
          </div>


